import { render } from "./tournament-list.vue?vue&type=template&id=3e25200e"
import script from "./tournament-list.vue?vue&type=script&lang=js"
export * from "./tournament-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__